import DateHelper from '@/utils/dateHelper'

/**
 * Configuration for Chart.js
 */
const CHART_OPTIONS = Object.freeze({
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: false,
    labels: {
      fontColor: '#000080',
      padding: 20
    }
  },
  scales: {
    //  Historical data graph settings
    xAxes: [{
      type: 'time',
      gridLines: {
        borderDash: [20, 1],
        color: '#ECECEC'
      },
      time: {
        unit: 'month'
      },
      ticks: {
        fontColor: '#4C4C4D',
        callback: value => {
          const date = value.split(' ')
          return `${date[0].toUpperCase()} ${date[1].toUpperCase()}`
        }

      }
    }],
    yAxes: [{
      gridLines: {
        borderDash: [20, 4],
        color: '#ECECEC'
      },
      ticks: {
        callback: tick => `${tick.toString()}%`
      }
    }]
  }
})

const DEFAULT_CHART_DATA = {
  labels: DateHelper.getLastNMonths(6).map(month => month.toUpperCase()),
  datasets: []
}

export { DEFAULT_CHART_DATA }
export { CHART_OPTIONS }
